<template>
  <l-layout :layout="['xs12']">
    <l-data-table
      :headers="header"
      :get-data-func="getApplyList"
      ref="teacherList"
      hide-title-search
      @click:row="getDetails($event.item)"
      :init-pagination="{sortBy: 'creationTime', descending: true}"
      clickable>
      <template slot="title">
        <span class="pl-2 pr-4">业务部门审核</span>
      </template>
      <template slot="row-action" slot-scope="{item}">
        <td @click.stop class="px-0 mx-0 text-xs-center">
          <v-btn icon :disabled="item.secondAuditStatus+''!=='0'" @click="review(item)">
            <v-icon>{{$vuetify.icons.edit}}</v-icon>
          </v-btn>
        </td>
      </template>
    </l-data-table>
  </l-layout>
</template>

<script>
  import LDataTable from "../../../ladmin/components/LDataTable/LDataTable";
  import {time} from "../../../ladmin/utils/time";
  function reviewStatusTrans(v){
    switch (v+'') {
      case '1':return '通过';
      case '2':return '已拒绝';
      case '0':return '待审核';
      case '-1':return 'N/A';
      default:return v;
    }
  }
  function reviewTypeTrans(v){
    if(v===null){
      return '职能部门审核'
    }
    switch (v+'') {
      case '1':return '科学研究类审核';
      case '2':return '本科生教学类审核';
      case '0':return '职能部门审核';
      case '3':return '研究生教学类审核';
      case '4':return '行政办公类';
      default:return v;
    }
  }
  export default {
    name: "secondReviewList_wx" ,
    components: {LDataTable},
    data(){
      return {
        header:[
          {text:'教工姓名',value:'name',sortable:false,align:'left'},
          {text:'教工编号',value:'loginId',sortable:false,align:'left'},
          {text:'所在单位',value:'orgName',sortable:false,align:'left',placeholder:'N/A'},
          {text:'申请时间',value:'creationTime',sortable:false,align:'left',placeholder:'N/A',f:(v)=>time.stringify(v)},
          {text:'计划进校时间',value:'stTime',sortable:true,align:"left"},
          {text:'进校事由类别',value:'reviewType',sortable:false,align:'left',f:(v)=>reviewTypeTrans(v)},
          {text:'进校事由详述',value:'reqComment',sortable:true,align:"left",maxWidth: '6em', tooltip: true},
          {text:'二级单位审核状态',value:'firstAuditStatus',sortable:false,align:'left',f:(v)=>reviewStatusTrans(v)},
          {text:'业务部门审核状态',value:'secondAuditStatus',sortable:false,align:'left',f:(v)=>reviewStatusTrans(v)},
          {text:'',value:'',sortable:false,align:'left'}
        ],
        selected:[],
        loading:false
      }
    },
    computed:{
      curOrg(){
        return this.$store.state.login.currentOrg
      }
    },
    methods:{
      dealPermission(filter){
        let permission = this.$store.state.login.permission
        console.log(permission)
        if(permission.temp===undefined){
          return filter
        }
        if(permission.temp.graduateAdmin!==undefined){
          filter.push({key:'reviewType',value:'3'})
          this.hasPermission = true
        }else if(permission.temp.scienceAdmin!==undefined){
          filter.push({key:'reviewType',value:'1'})
          this.hasPermission = true
        } else if(permission.temp.undergraduateAdmin!==undefined){
          filter.push({key:'reviewType',value:'2'})
          this.hasPermission = true
        }else if(permission.temp.agentAdmin!==undefined){
          filter.push({key:'reviewType',value:'4'})
          this.hasPermission = true
        }else if(permission.temp.secondAdmin!==undefined){
          this.hasPermission = true
        }
        return filter
      },
      async getApplyList({pagination}){
        let filter = [
          {key:'secondAuditStatus',value:'0'},
          {key:'auditType',value:'0'}
        ]
        filter = this.dealPermission(filter)
        let {items,amount} = await this.$store.dispatch('school/getApplyList',{pagination:pagination,search:{key:'firstAuditStatus',value:'1'},filter:filter})
        for(let i=0;i<items.length;i++){
          let item = items[i]
          if(item.firstAuditStatus+''==='0'||item.firstAuditStatus+''==='2'){
            item.secondAuditStatus = '-1'
          }
        }
        return {items:items,amount:amount}
      },
      review(item){
        this.$router.push({name:'tempReviewDetail_wx',
          query:{
            id:item.id,
            type:'2'
          }
        })
      },
      getDetails(item){
        if(item.firstAuditStatus+''==='0'||item.secondAuditStatus+''!=='0') {
          this.$router.push({name:'tempReviewDetail_wx',query:{id:item.id,status:'readonly'}})
        }else{
          this.$router.push({name:'tempReviewDetail_wx',query:{id:item.id,status:'review',type:'2'}})
        }
      }
    }
  }
</script>

<style scoped>

</style>
